module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"import":"Datenimport"},"en":{"import":"Import"}}')
  delete Component.options._Ctor
}
